export const AppStoreLink = 'https://apps.apple.com/au/app/tapt/id1641630762';
export const PlayStoreLink =
  'https://play.google.com/store/apps/details?id=io.tapt.mobile_app';
